<h2 mat-dialog-title>AI Settings 🤖</h2>
<mat-dialog-content class="mat-typography">
  <div *ngFor="let conf of config; let i = index" class="ai-step-item" [class.step-deactivate] = "conf.deactivate">
    <div class="ai-settings-main-grid" autofocus>
      <div>
        <mat-form-field class="ai-settings-prompt-textarea">
          <mat-label>Prompt</mat-label>
          <textarea [(ngModel)]="conf.prompt" matInput></textarea>
        </mat-form-field>
        <br>

        <div class="ai-settings-prompt-grid">
<!--          <mat-form-field class="gse-grid-item__name" appearance="fill">-->
<!--            <mat-label>n</mat-label>-->
<!--            <input matInput [(ngModel)]="conf.n">-->
<!--          </mat-form-field>-->

          <mat-form-field class="gse-grid-item__name" appearance="fill">
            <mat-label>temperature</mat-label>
            <input matInput [(ngModel)]="conf.temperature">
          </mat-form-field>
          <br>

          <ngx-codemirror
            *ngIf="codeReady"
            #codeMirror
            [(ngModel)]="conf.function"
            [options]="codemirrorConfig"
            [autoFocus]="true"
            (cursorActivity)="cursorActivity($event)"
            (ngModelChange)="setEditorContent($event)"
          ></ngx-codemirror>
<!--          <mat-form-field class="gse-grid-item__name" appearance="fill">-->
<!--            <mat-label>top_p</mat-label>-->
<!--            <input matInput [(ngModel)]="conf.top_p">-->
<!--          </mat-form-field>-->


<!--          <mat-form-field class="gse-grid-item__name" appearance="fill">-->
<!--            <mat-label>presence_penalty</mat-label>-->
<!--            <input matInput [(ngModel)]="conf.presence_penalty">-->
<!--          </mat-form-field>-->


<!--          <mat-form-field class="gse-grid-item__name" appearance="fill">-->
<!--            <mat-label>frequency_penalty</mat-label>-->
<!--            <input matInput [(ngModel)]="conf.frequency_penalty">-->
<!--          </mat-form-field>-->

<!--          <mat-form-field class="gse-grid-item__name" appearance="fill">-->
<!--            <mat-label>chunk_size</mat-label>-->
<!--            <input [disabled]="i === 0" matInput [(ngModel)]="conf.chunk_size">-->
<!--          </mat-form-field>-->

<!--          <div style="margin-left: 15px;">-->
<!--            <section class="example-section">-->
<!--              <mat-checkbox class="example-margin" [(ngModel)]="conf.json">JSON response</mat-checkbox>-->
<!--            </section>-->
<!--            <section class="example-section" *ngIf="i !== 0">-->
<!--              <mat-checkbox class="example-margin" [(ngModel)]="conf.deactivate">Deactivate</mat-checkbox>-->
<!--            </section>-->
<!--          </div>-->
        </div>
<!--        <button mat-stroked-button color="primary">logit_bias</button>-->
<!--        <mat-form-field class="ai-settings-prompt-textarea ai-settings-prompt-textarea&#45;&#45;logit">-->
<!--          <mat-label>logit_bias</mat-label>-->
<!--          <textarea [(ngModel)]="conf.logit_bias" matInput></textarea>-->
<!--        </mat-form-field>-->
      </div>
      <div>
        <button mat-icon-button [matMenuTriggerFor]="gmcmenu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu class="primary" #gmcmenu="matMenu">
<!--          <button mat-menu-item (click)="runTest(i)">Run Test</button>-->
<!--          <button mat-menu-item (click)="addFunction(i)">Function</button>-->
          <button *ngIf="i !== 0" (click)="deleteStep(i)" mat-menu-item>
            <mat-icon>delete</mat-icon>
            <span>Delete Step</span>
          </button>
        </mat-menu>
      </div>
    </div>
  </div>

  <div style="display: flex; align-items: center; justify-content: center; margin-top: 15px;">
    <button (click)="addStep()" mat-stroked-button color="primary">Add Step</button>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cancel</button>
<!--  <button mat-button (click)="close()">Ru</button>-->
  <button mat-raised-button color="primary" (click)="save()">Save</button>
</mat-dialog-actions>
